module.exports = __webpack_public_path__ + "img/warranty.74eb9540.png";